<template>
    <ul class="checklist details-list text-left">
        <li v-for="(item, index) in items" :key="'item' + index" v-bind="{ ...liAttrs }">
            <IconSvg filepath="tick.svg" class="tick-svg" />
            <slot :item="item" :index="index">
                <span v-html="item"></span>
            </slot>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'CheckList',
    props: {
        items: {
            type: Array
        },
        liAttrs: {
            type: Object
        }
    }
};
</script>

<style scoped lang="scss">
ul.checklist {
    $line-height: 1.5em;
    $padding-y: 0.5em;
    li {
        position: relative;
        padding: 0 0 $padding-y 2em;
        line-height: $line-height;

        .icon-tick {
            fill: var(--primary);
            width: 1em;
            height: $line-height;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
}
</style>
